// Self-hosted Inter and Poppins in the weights the app uses, so the app makes
// no third-party font request.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";

import App from "./App";
import { initializeFirebaseAuth } from "./auth/helloCashflowDomain/firebase";
import { initAuthStoreSync } from "./lib/firebase/authStoreSync";
import { getAdminDepartureHistory } from "./routing/adminDepartureRuntime";
import { AdminNavigationGuard } from "./routing/AdminNavigationGuard";
import { store } from "./store/store";
import { registerViteChunkLoadRecovery } from "./utils/registerViteChunkLoadRecovery";

// Initialize Firebase using the shared library's dependency injection system
initializeFirebaseAuth();
// Initialize the Auth <-> Store sync (moved out of lib/firebase.ts to avoid circular deps)
initAuthStoreSync();
registerViteChunkLoadRecovery();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container #root was not found.");
}

getAdminDepartureHistory().install();
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <AdminNavigationGuard>
        <App />
      </AdminNavigationGuard>
    </BrowserRouter>
  </Provider>,
);
